import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Breadcrumbs from 'react-router-dynamic-breadcrumbs';

import { Redirect } from 'react-router-dom';

import {
  APIHandler,
  DataHandler,
  ItemCollection,
} from 'C4';

const capitalize = s => `${s[0].toUpperCase()}${s.substring(1)}`;

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: null,
      crumbRoutes: {},
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
    this.stringToObject = this.stringToObject.bind(this);
  }

  componentDidMount() {
    this.init();

    document.addEventListener('keydown', this.onEsc);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc({ key }) {
    if (key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  async getCollection(appId) {
    const { url } = this.props.match;
    const { match: { params: { contentType } } } = this.props;
    if (url.split('/').slice(-2).pop() === 'images' || url.split('/').slice(-2).pop() === 'videos') {
      return APIHandler[`get${capitalize(url.split('/').slice(-1).pop())}`](appId);
    }
    return APIHandler.getCollection(appId, contentType, true);
  }

  stringToObject(item, i) {
    const { match: { params: { contentType } } } = this.props;
    const itemUrl = `app/72/salesCompanion/${contentType}/${item}`;

    return {
      url: itemUrl,
      image: `https://cdn.travpromobile.com/apptool/${itemUrl}`,
      title: `${capitalize(contentType.replace(/(?!^.*)s$/g, ''))} ${i + 1}`,
      pageID: itemUrl,
      type: item.endsWith('.mp4') ? 'video' : 'photo',
      photoCredits: '',
      chapter: {
        chapterNumber: '',
        chapterTitle: contentType,
        chapterImage: itemUrl,
      },
    };
  }

  async init() {
    const { match: { url, params: { contentType } } } = this.props;
    const appId = await DataHandler.matchAppId();

    const routes = new RegExp('^(((/.*?/).*?/).*?/)', 'g')
      .exec(`${url}/`)
      .slice(1)
      .reverse()
      .map(val => val.substring(0, val.length - 1));

    const crumbs = {};
    routes.forEach((route) => {
      const [lastRoute] = route.split('/').slice(-1);
      crumbs[route] = capitalize(lastRoute);
    });

    const { items: collection } = await this.getCollection(appId) || {};
    const parsedCollection = Object.values(collection).every(item => item.length === 0)
      ? { [contentType]: Object.keys(collection).map(this.stringToObject) }
      : collection;

    this.setState({
      crumbRoutes: crumbs,
      collection: parsedCollection,
    });
  }

  render() {
    const {
      escaped, crumbRoutes, collection,
    } = this.state;

    const { match: { url, params: { videoId } } } = this.props;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="collection__Container">
        <div className="collection__Background--overlay" />
        <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
          LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
        />
        {/* BackButton needs to take the SECOND to last route */}
        {collection &&
          Object.keys(collection).map((key) => {
            const contentItems = collection[key];

            return contentItems.length > 0 && (
              <ItemCollection
                key={key}
                chapter={typeof contentItems === 'object' ? contentItems : null}
                item={typeof contentItems === 'string' ? contentItems : null}
              />
            );
          })}
        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
